import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { PdfViewer } from '../PdfViewer';
import type { PdfPreviewModalProps } from '../../types/pdf.types';

export function PdfPreviewModal({ open, onClose, document }: PdfPreviewModalProps) {
  if (!document) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 1,
        }}
      >
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            pr: 2,
          }}
        >
          {document.fileName}
        </Box>
        <IconButton
          edge="end"
          onClick={onClose}
          aria-label="Schliessen"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <PdfViewer
          documentId={document.id}
          fileName={document.fileName}
        />
      </DialogContent>
    </Dialog>
  );
}
